import {
  JOB_BOARD_EDIT_POPUP_SEARCH_TEXT,
  JOB_BOARD_EDIT_POPUP_SET_ACTIVE_QUOTE_INDEX,
  JOB_BOARD_EDIT_POPUP_SET_JOB_INFO,
  JOB_BOARD_EDIT_POPUP_SET_JOB_CART_ITEMS,
  JOB_BOARD_SHOW_EDIT_POPUP,
  JOB_BOARD_EDIT_POPUP_SET_IFRAME_LOADING,
  JOB_BOARD_EDIT_POPUP_SET_IFRAME_WAITING,
  JOB_BOARD_EDIT_POPUP_USE_FAB_PRICES,
  JOB_BOARD_EDIT_POPUP_USE_TAXES,
  JOB_BOARD_SHOW_PURCHASE_ORDER_POPUP,
  JOB_BOARD_EDIT_POPUP_SET_IFRAME_WAITING_RECEIPT, JOB_BOARD_UPDATE_JOB,
} from "../../../constants/actionTypes";

const initialState = {
  job: null,
  jobCartItems: [],
  jobTotal: {},
  jobUseFabricatorCostPrices: false,
  jobUseTaxes: true,
  jobEditPopupActiveQuoteIndex: null,
  jobEditPopupRoomNames: [], // "Kitchen A", "Kitchen B", "Bathroom"
  jobEditPopupIframeLoading: false,
  jobEditPopupIframeWaiting: false,
  jobEditPopupIframeWaitingReceipt: false,
};

export default function jobEditPopupState(state = initialState, action) {
  switch(action.type) {
    case JOB_BOARD_SHOW_EDIT_POPUP:
    case JOB_BOARD_SHOW_PURCHASE_ORDER_POPUP:
      console.log("job", action.payload.job);
      if (action.payload.showJobEditPopup) {
        return {...state, job: action.payload.job ? action.payload.job : null}
      }
      if (action.payload.showJobPurchaseOrderPopup) {
        return {
          ...state,
          job: action.payload.job ? action.payload.job : null,
          jobTotal: {
            totalWithTaxes: action.payload.job ? action.payload.job.grandTotal || action.payload.job.total : 0
          }
        }
      }
      return {...state, job: null, jobCartItems: [], jobTotal: {}};
    case JOB_BOARD_EDIT_POPUP_SET_JOB_INFO:
    case JOB_BOARD_EDIT_POPUP_SET_ACTIVE_QUOTE_INDEX:
    case JOB_BOARD_EDIT_POPUP_SET_JOB_CART_ITEMS:
    case JOB_BOARD_EDIT_POPUP_SEARCH_TEXT:
    case JOB_BOARD_EDIT_POPUP_SET_IFRAME_LOADING:
    case JOB_BOARD_EDIT_POPUP_USE_FAB_PRICES:
    case JOB_BOARD_EDIT_POPUP_SET_IFRAME_WAITING:
    case JOB_BOARD_EDIT_POPUP_SET_IFRAME_WAITING_RECEIPT:
    case JOB_BOARD_EDIT_POPUP_USE_TAXES:
      return {...state, ...action.payload};
    case JOB_BOARD_UPDATE_JOB:
      if (state.job && action.payload.job && action.payload.properties && (state.job.id === action.payload.job.id)) {
        return {...state, job: {...action.payload.job, ...action.payload.properties}};
      }
      return state
    default:
      return state;
  }
}
